<template>
    <CRow>
        <CCol>
            <CCard v-if="entity">
                <CCardHeader>
                    <strong>{{ entity.name }}</strong>
                </CCardHeader>
                <CCardBody>
                    <ConciergeTabLinks />
                    <ConciergeCard :entity="entity" />
                </CCardBody>

                <CCardFooter>
                    <CButton
                        class="mr-2"
                        :color="entity.online ? 'danger' : 'primary'"
                        @click="setWorkStatus"
                    >{{ entity.online ? 'Звершить смену' : 'Начать смену' }}</CButton>
                    <CButton
                        class="mr-2"
                        :color="entity.at_lunch ? 'danger' : 'primary'"
                        :disabled="!entity.online"
                        @click="setLunch"
                    >{{ entity.at_lunch ? 'Звершить перерыв' : 'Начать перерыв' }}</CButton>
                    <CButton
                        color="primary"
                        @click="$router.push(`/concierges`)"
                    >Назад</CButton
                    >
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import ConciergeTabLinks from '@/components/concierges/ConciergeTabLinks';
    import ConciergeCard from '@/components/concierges/ConciergeCard';

    export default {
        name: 'Concierge',

        components: {
            ConciergeTabLinks,
            ConciergeCard,
        },

        data() {
            return {
                entity: undefined,
            };
        },

        async created() {
            await this.fetch();
        },

        methods: {
            async fetch() {
                const { id } = this.$route.params;
                this.entity = (await this.axios.get(`/concierges/${id}`)).data;
            },
            async setWorkStatus () {
                const { id } = this.$route.params;
                this.entity = (await this.axios.post(`/concierges/${id}/work-status`, { online: !this.entity.online })).data;
                await this.fetch();
            },
            async setLunch () {
                const { id } = this.$route.params;
                this.entity = (await this.axios.post(`/concierges/${id}/lunch-status`, { at_lunch: !this.entity.at_lunch })).data;
                await this.fetch();
            },
        },
    };
</script>
